import axios from '@/api/config';

const generatorProperty = {
  getGeneratorProperty(data) {
    return axios.get(`${process.env.BASE_URL}/generatorProperty/getGeneratorProperty/` + data, {});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/generatorProperty/pageList`, data);
  },
  addGeneratorProperty(data) {
    return axios.post(`${process.env.BASE_URL}/generatorProperty/addGeneratorProperty`, data);
  },
  updateGeneratorProperty(data) {
    return axios.put(`${process.env.BASE_URL}/generatorProperty/updateGeneratorProperty`, data);
  },
  deleteGeneratorProperty(data) {
    return axios.delete(`${process.env.BASE_URL}/generatorProperty/deleteGeneratorProperty`, {data: data});
  },
  getByTableSchema(data) {
    return axios.get(`${process.env.BASE_URL}/generatorProperty/getByTableSchema`, {params: data});
  },
  getLastTableSchema(data) {
    return axios.get(`${process.env.BASE_URL}/generatorProperty/getLastTableSchema`, {params: data});
  },
}

export default generatorProperty;



// WEBPACK FOOTER //
// ./src/api/generatorProperty.js